import _get from 'lodash/get'

import {
    OTHER_INCOME_SAVE_ERROR,
    OTHER_INCOME_SAVE_SUCCESS,
    OTHER_INCOME_SAVING,
    OTHER_INCOME_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        activeQuestionIndex: 0,
        activeQuestionNumber: 1,
    },
    action
) => {
    switch (action.type) {
        case OTHER_INCOME_UPDATE:
            return { ...state, ...action.otherIncome }

        case OTHER_INCOME_SAVING:
            return { ...state, isSaving: true }

        case OTHER_INCOME_SAVE_SUCCESS:
            return {
                ...state,
                isSaving: false,
                goToNextQuestion: true,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }
        case OTHER_INCOME_SAVE_ERROR:
            return {
                ...state,
                ...action.otherIncome,
                isSaving: false,
                goToNextQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
